import React from "react";
import { connect } from "react-redux";

import styles from "../../../../styles/stylesgenerales";
import { Button, TextBox } from "devextreme-react";
import {
  // createUserAD,
  doCreateUserTempBD,
} from "../actions";
import { paths } from "../../../../config/routes";
import LoadingOverlay from "../../../Shared/LoadingOverlay";
import { Tooltip } from "devextreme-react/ui/tooltip";
import helper from "../../../../helpers/validaciones";

class CreatePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pass: null,
      rePass: null,
      passValid: false,
      formPassValid: false,
      showTooltip: false,
      resultPass: false,
      // resultRePass: false,
    };

    this.passComponent = React.createRef();
    this.rePassComponent = React.createRef();


    // paso cuatro
    this.handleChangePassword = this.handleChangePassword.bind(this);

    // success
  }

  handlePaste = (e) => {
    e.event.preventDefault();
  }

  handleValidForm = () => {
    const res = this.state.pass === this.state.rePass && this.state.passValid;
    this.setState({
      formPassValid: res,
    });
  }

  // paso cuatro
  handleChangePassword(e) {
    const ident = (typeof e === "object") ? e.element.id : "";

    switch (ident) {
      case "pass": {
        const valid = true;
        let passOk = true;

        const result = helper.passValidation(e.value);
        if (!result.strongRegex) {
          e.component.option({
            validationError: { message: "Contraseña no cumple con los parámetros mínimos" },
            isValid: valid,
          });
          passOk = false;
        } else if ((e.value !== this.state.rePass) && this.state.rePass !== null) {
          e.component.option({
            validationError: { message: "Las contraseñas no coinciden" },
            isValid: valid,
          });
          this.rePassComponent.option({ isValid: false });
        } else {
          e.component.option({
            isValid: true,
          });
          this.rePassComponent.option({ isValid: true });
        }

        this.setState({ pass: e.value, passValid: passOk, resultPass: result });


        break;
      }
      case "rePass": {
        let valid = true;
        if (this.state.pass !== null) {
          valid = this.state.pass === e.value;
        }
        e.component.option({
          validationError: { message: "La contraseña no coincide con la anterior" },
          isValid: valid,
        });

        this.setState({ rePass: e.value });

        break;
      }

      default:
        break;
    }
    this.handleValidForm();
  }
  doCreateUser() {
    const personalData = this.props.UserInfo;
    personalData.Password = this.state.pass;
    personalData.UserType = "emailAddress";

    if (this.props.UserInfo.TempBD) {
      // llamo action para agregar registro en base temporal
      this.props.dispatch(doCreateUserTempBD(personalData, paths.registroEmpresa));
    }
  }
  renderCreatePassword() {
    return (
      <center>
        <div className="acceso row">
          {this.props.isLoading && <LoadingOverlay style={{ height: 700 }} />}
          <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
            <h4> Crear Contraseña</h4>
          </div>
          <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
            <p style={{ color: "#E62A3B" }} className="danger text-center"> {this.props.messageCreateUser} </p>
          </div>
          <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
            <h3><p className="text-left">Contraseña</p></h3>

            <Tooltip
              className="tooltip-messege"
              visible={this.state.showTooltip}
              contentRender={() =>
                (

                  <React.Fragment>
                    <div className="tooltip-custom-content" >
                      {this.state.resultPass.regxMin === true ?
                        <div className="success"><i className="material-icons">done </i><span className="text">Mínimo 8 caracteres</span> </div>
                        : <div className="default"> <i className="material-icons">error_outline</i><span className="text">Mínimo 8 caracteres</span> </div>
                      }
                    </div>
                    <div className="tooltip-custom-content" >
                      {this.state.resultPass.regxCapital === true ?
                        <div className="success"><i className="material-icons">done </i><span className="text">Mayúsculas</span> </div>
                        : <div className="default"> <i className="material-icons">error_outline</i><span className="text">Mayúsculas</span> </div>
                      }
                    </div>
                    <div className="tooltip-custom-content" >
                      {this.state.resultPass.regxNumber === true ?
                        <div className="success"><i className="material-icons">done </i><span className="text">Números</span> </div>
                        : <div className="default"> <i className="material-icons">error_outline</i><span className="text">Número</span> </div>
                      }
                    </div>
                    <div className="tooltip-custom-content" >
                      {this.state.resultPass.regxSpecialCaracters === true ?
                        <div className="success"><i className="material-icons">done </i><span className="text">Simbolos {"#?!@$%^&*-,.()+:;<>=[^_`{}|~'/"} </span> </div>
                        : <div className="default"> <i className="material-icons">error_outline</i><span className="text">Simbolos {"#?!@$%^&*-,.()+:;<>=[^_`{}|~'/"} </span> </div>
                      }
                    </div>
                  </React.Fragment>


                )}
              position="top"
              target="#pass"
            />
            <TextBox
              id="pass"
              placeholder="Contraseña"
              mode="password"
              ref={(ref) => ref != null ? this.passComponent = ref.instance : null}
              onValueChanged={this.handleChangePassword}
              valueChangeEvent="input"
              onFocusIn={() => this.setState({ showTooltip: true })}
              onFocusOut={() => this.setState({ showTooltip: false })}
            />
          </div>
          <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >

            <h3><p className="text-left">Repetir Contraseña</p></h3>
            <TextBox
              id="rePass"
              placeholder="Repetir Contraseña"
              mode="password"
              ref={(ref) => ref != null ? this.rePassComponent = ref.instance : null}
              onPaste={this.handlePaste}
              onValueChanged={this.handleChangePassword}
              valueChangeEvent="focusout"
            />
          </div>
          <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
          </div>
          <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ textAlign: "center" }}>
            <Button text="Siguiente" style={styles.fullWidth} type="success" disabled={!(this.state.formPassValid)} onClick={() => this.doCreateUser()} />
          </div>
        </div>
      </center>);
  }


  render() {
    return (

      <div className="container-fluid" style={{ padding: 0, margin: 0 }}>
        {this.renderCreatePassword()}
      </div>

    );
  }
}

const mapStateToProps = (state) => ({
  UserInfo: state.userRegister.UserInfo,
  messageCreateUser: state.userRegister.messageCreateUser,
  isLoading: state.global.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePassword);

